import QuestionMarkIcon from "../../assets/icons/notification/question-mark.svg";
import RewardPersonIcon from "../../assets/icons/notification/reward-person.svg";
import BatchesIcon from "../../assets/icons/notification/batches_icon.svg";
import TickMarkIcon from "../../assets/icons/notification/tick-mark.svg";
import StudentIcon from "../../assets/icons/notification/student.svg";
import DownloadIcon from "../../assets/icons/notification/download.svg";
import RemovedIcon from "../../assets/icons/cross_active.svg";
import NewsIcon from "../../assets/icons/notification/news_icon.svg";

import {
  AscRoundedTagTypes,
  AdminNotificationType,
  SHARED_ADMIN_ROUTES,
  AuthUserRole,
  appConfig,
} from "@ascendnow/shared";

interface INotificationTypeHandler {
  route?: string;
  tag: AscRoundedTagTypes;
  icon: string;
}

export function adminNotificationTypeHandler(
  type: AdminNotificationType,
  body?: {
    [key: string]: string;
  },
  role?: AuthUserRole
): INotificationTypeHandler {
  switch (type) {
    case AdminNotificationType.UPLOADED_STUDENTS_CSV:
    case AdminNotificationType.STUDENT_ADDED:
    case AdminNotificationType.STUDENT_PROFILE_EDITED:
      return {
        route:
          role === appConfig.role.SCHOOL_OWNER
            ? SHARED_ADMIN_ROUTES.studentsControl
            : SHARED_ADMIN_ROUTES.students,
        tag: "tag",
        icon: StudentIcon,
      };
    case AdminNotificationType.STUDENT_REMOVED:
      return {
        route:
          role === appConfig.role.SCHOOL_OWNER
            ? SHARED_ADMIN_ROUTES.studentsControl
            : SHARED_ADMIN_ROUTES.students,
        tag: "tag",
        icon: RemovedIcon,
      };
    case AdminNotificationType.BATCH_CREATED:
    case AdminNotificationType.STUDENT_ADDED_TO_BATCH:
    case AdminNotificationType.STUDENT_REMOVED_FROM_BATCH:
      return {
        route: body?.batchId
          ? SHARED_ADMIN_ROUTES.singleBatch(body?.batchId)
          : "/",
        tag: "tag",
        icon: BatchesIcon,
      };
    case AdminNotificationType.CREDITS_PURCHASED:
    case AdminNotificationType.INVOICE_DOWNLOADED:
      return {
        route: SHARED_ADMIN_ROUTES.billing,
        tag: "tag",
        icon: TickMarkIcon,
      };
    case AdminNotificationType.TEAM_MEMBER_ADDED_TO_TEAM:
    case AdminNotificationType.TEAM_MEMBER_ROLE_CHANGED:
    case AdminNotificationType.TEAM_MEMBER_REMOVED:
      return {
        route: SHARED_ADMIN_ROUTES.team,
        tag: "tag",
        icon: RewardPersonIcon,
      };
    case AdminNotificationType.ACTION_LOG_DOWNLOADED:
      return {
        route: SHARED_ADMIN_ROUTES.team,
        tag: "tag",
        icon: DownloadIcon,
      };
    case AdminNotificationType.NEW_NEWS_ITEMS:
      return {
        route: SHARED_ADMIN_ROUTES.posts,
        tag: "tag",
        icon: NewsIcon,
      };
    default:
      return {
        route: "/",
        tag: "tag",
        icon: QuestionMarkIcon,
      };
  }
}
